import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const PaymentReceiptPrint = () => {
    const [payment, setPayment] = useState(null);

    useEffect(() => {
        const storedPayment = localStorage.getItem('print_payment');
        if (storedPayment) {
            setPayment(JSON.parse(storedPayment));
        } else {
            // بيانات افتراضية للمعاينة فقط
            setPayment({
                id: "163",
                student: {
                    full_name: "ابتسام ايت فارس",
                    code_massar: "0",
                    institution: { name: "عقبة بن نافع" },
                    school_class: { name: "1 ابتدائي" },
                    address: "دوار ايت امغار"
                },
                months: ["شتنبر 2019"],
                payment_date: "01 / 09 / 2019",
                amount: "100,00"
            });
        }
        const timer = setTimeout(() => {
            window.print();
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    if (!payment) return <div className="text-center p-10">جاري تحميل البيانات...</div>;

    return (
        <div className="receipt-container">
            <table className="outer-table">
                <tbody>
                    {/* السطر الأول: اللوغو في اليمين والمعلومات في اليسار */}
                    <tr>
                        <td className="info-header-cell" style={{position: 'relative', minHeight: '100px'}}>
                            <div style={{position: 'absolute', left: '15px', top: '10px'}}>
                                <QRCodeSVG value={payment.student?.qr_code || payment.student?.code_massar || String(payment.id)} size={80} level="H" />
                            </div>
                            <div className="flex-row">
                                <span className="label">التلميذ(ة) :</span>
                                <span className="value-bold">{payment.student?.full_name}</span>
                            </div>
                            <div className="flex-row" style={{ marginTop: '8px' }}>
                                <span className="label">رقم المسار :</span>
                                <span className="value-bold" style={{ fontSize: '13px' }}>{payment.student?.code_massar || '--'}</span>
                            </div>
                            <div className="flex-row" style={{ marginTop: '4px' }}>
                                <span className="label">رقم البطاقة :</span>
                                <span className="value-bold" style={{ fontSize: '13px' }}>{payment.student?.qr_code || '--'}</span>
                            </div>
                        </td>
                        <td className="logo-cell">
                            <img src="/logo.png" alt="شعار الجمعية" style={{height: '60px', margin: '0 auto', marginBottom: '5px'}} />
                            <p className="assoc-title">جمعية تنمية</p>
                            <p className="assoc-subtitle">النقل المدرسي</p>
                            <p className="assoc-subtitle">ولاد دحو</p>
                        </td>
                    </tr>

                    {/* عنوان التوصيل */}
                    <tr >
                        <td colSpan="2" className="receipt-title">
                            <span style={{ fontSize: payment.months?.join(' ').length > 20 ? '16px' : '14px' }}>
                                توصيل شهر {payment.months?.join(' ')}
                            </span>
                        </td>
                    </tr>

                    {/* رقم الوصل ورقم البطاقة مع حدود عمودية */}
                    <tr>
                        <td className="border-left cell-center">
                            <span className="label">رقم الوصل :</span>
                            <span className="value-bold">{payment.id}</span>
                        </td>
                        <td className="cell-center">
                            <span className="label">تاريخ الأداء :</span>
                            <span className="value-bold">{payment.payment_date}</span>
                        </td>
                    </tr>

                    {/* الجزء الرئيسي: المعلومات (يمين) والختم (يسار) */}
                    <tr>
                        <td className="details-table-cell border-left">
                            <table className="inner-info-table">
                                <tbody>
                                    <tr>
                                        <td className="inner-label">المؤسسة :</td>
                                        <td className="inner-val">{payment.student?.institution?.name || '--'}</td>
                                    </tr>
                                    <tr>
                                        <td className="inner-label">القسـم :</td>
                                        <td className="inner-val">{payment.student?.school_class?.name || '--'}</td>
                                    </tr>

                                    <tr>
                                        <td className="inner-label">العنوان :</td>
                                        <td className="inner-val">{payment.student?.address || '--'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td className="stamp-cell">
                            <span className="label">خاتم الجمعية :</span>
                            <div className="stamp-circle"></div>
                        </td>
                    </tr>

                    {/* وسيلة الأداء والواجب أداؤه */}
                    <tr>
                        <td className="amount-row border-left">
                            <div className="flex-row" style={{ flexWrap: 'wrap', gap: '10px' }}>
                                <div>
                                    <span className="label">وسيلة الأداء :</span>
                                    <span className="value-bold">{payment.payment_mode_details?.name || payment.payment_mode}</span>
                                </div>
                                {payment.cheque_number && (
                                    <div style={{ borderRight: '2px solid #000', paddingRight: '10px' }}>
                                        <span className="label">رقم الشيك :</span>
                                        <span className="value-bold" style={{ fontSize: '14px' }}>{payment.cheque_number}</span>
                                    </div>
                                )}
                            </div>
                        </td>
                        <td className="amount-row text-left-important">
                            <span className="label" style={{fontSize: '16px'}}>الواجب أداؤه :</span>
                            <span className="amount-val">{payment.amount}</span>
                        </td>
                    </tr>

                    {/* التذييل */}
                    <tr>
                        <td colSpan="2" className="footer-row">
                            <span>أولاد دحو في : {payment.payment_date}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <style dangerouslySetInnerHTML={{__html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap');
                
                .receipt-container {
                    width: 190mm;
                    padding: 5px;
                    margin: 0 auto;
                    direction: rtl;
                    font-family: 'Cairo', sans-serif;
                    background: #fff;
                    box-sizing: border-box;
                }

                .outer-table {
                    width: 100%;
                    border-collapse: collapse;
                    border: 2px solid #000;
                }

                .outer-table td {
                    border: 1px solid #000;
                    padding: 4px 8px;
                    vertical-align: middle;
                }

                /* تنسيق النصوص */
                .label { font-weight: bold; margin-left: 8px; font-size: 13px; }
                .value-bold { font-weight: bold; font-size: 16px; }

                /* اللوغو (يمين) */
                .logo-cell { width: 30%; text-align: center; }
                .assoc-title { font-weight: bold; font-size: 14px; margin: 0; }
                .assoc-subtitle { font-size: 12px; margin: 0; font-weight: bold; }

                /* الترويسة */
                .receipt-title { text-align: center; font-weight: bold; padding: 7px !important; line-height: 1.2; }

                /* المحاذاة والحدود */
                .cell-center { text-align: center; vertical-align: middle !important; width: 50%; height: 35px; }
                .border-left { border-left: 1px solid #000 !important; }

                /* جدول المعلومات الداخلي (يمين) */
                .details-table-cell { padding: 0 !important; width: 65%; vertical-align: top; }
                .inner-info-table { width: 100%; border-collapse: collapse; }
                .inner-info-table td { border: none !important; border-bottom: 1px solid #000 !important; padding: 4px 10px !important; height: 30px; }
                .inner-label { width: 110px; font-weight: bold; border-left: 1px solid #000 !important; text-align: right; font-size: 12px; }
                .inner-val { text-align: center; font-weight: bold; font-size: 13px; }

                /* الختم (يسار) */
                .stamp-cell { width: 35%; height: 140px; text-align: center; padding: 5px !important; }
                .stamp-circle { 
                    width: 80px; height: 80px; 
                    border: 1px dashed #999; 
                    border-radius: 50%; 
                    margin: 10px auto; 
                }

                /* الواجب أداؤه */
                .amount-row { padding: 8px 15px !important; width: 50%; }
                .amount-val { font-size: 24px; font-weight: bold; margin-right: 10px; font-family: sans-serif; }
                .text-left-important { text-align: left !important; }

                /* التاريخ */
                .footer-row { text-align: left; padding-left: 50px !important; font-weight: bold; font-size: 14px; height: 35px; }

                .flex-row { display: flex; align-items: center; }

                @media print {
                    @page { margin: 0; size: auto; }
                    body { margin: 0; padding: 0; background: white; }
                    .receipt-container { 
                        width: 100%; 
                        max-width: 190mm;
                        height: auto; 
                        padding: 5mm; 
                        margin: 0; 
                        page-break-after: avoid;
                    }
                }
            `}} />
        </div>
    );
};

export default PaymentReceiptPrint;